//@flow
import React, { useEffect, useState } from 'react';
import Slider from 'react-slick';
import DisabledArrow from 'assets/images/Carausel-arrows-disabled.png';
import EnabledArrow from 'assets/images/Carausel-arrows-active.png';
import './styles.scss';

type Props = {
  data: Array<RestaurantCategory>,
};

export const TextCarouselMobile = (props: Props) => {
  const {
    outletFoodCategory,
    selectedFoodCategoryValue,
    selectedId,
    selectedItem,
  } = props;
  const [slider, setSlider] = useState();
  const calculateWidth = () => {
    let parentEle = document.querySelector('.food-category-carousel');
    let parentWidth = parentEle && parentEle.offsetWidth;
    let childEle = parentEle && parentEle.getElementsByClassName('slick-slide');
    let collection = childEle ? childEle : [];
    let total_width = 0;
    for (let i = 0; i < collection.length; i++) {
      total_width = total_width + childEle[i].offsetWidth;
    }
    return parentWidth < total_width;
  };
  useEffect(() => {
    calculateWidth();
  });
  const [activeSlide, setActiveSlide] = useState(0);
  const settings = {
    dots: false,
    infinite: false,
    // slidesToShow: 4,
    slidesToScroll: 1,
    arrows: false,
    verticalSwiping: false,
    speed: 1000,
    touchThreshold: 3000,
    centerMode: false,
    variableWidth: true,
    draggable: calculateWidth(),
    beforeChange: (current, next) => setActiveSlide(next),
  };
  const onNextClick = () => {
    slider.slickNext();
  };
  const onPreviousClick = () => {
    slider.slickPrev();
  };
  const leftArrow = () => {
    if (activeSlide === 0) {
      return (
        <img
          src={DisabledArrow}
          alt="Left Arrow"
          style={{ cursor: 'default', pointerEvents: 'none' }}
        />
      );
    } else {
      return (
        <img src={EnabledArrow} alt="Left Arrow" onClick={onPreviousClick} />
      );
    }
  };
  const rightArrow = () => {
    const endOfSlide = outletFoodCategory.length - 1 === activeSlide;
    if (endOfSlide) {
      return (
        <img
          src={DisabledArrow}
          alt="Left Arrow"
          style={{ cursor: 'default', pointerEvents: 'none' }}
        />
      );
    } else {
      return <img src={EnabledArrow} alt="Left Arrow" onClick={onNextClick} />;
    }
  };
  const renderFoodCategoryCarousel = () => {
    outletFoodCategory &&
      selectedFoodCategoryValue &&
      outletFoodCategory.sort(function(x, y) {
        return x.id === selectedFoodCategoryValue.value
          ? -1
          : y.id === selectedFoodCategoryValue.value
          ? 1
          : 0;
      });
    return outletFoodCategory.map((foodCategory, idx) => (
      <div
        key={idx}
        onClick={() => selectedItem(foodCategory.id, foodCategory, idx)}
        className={'text-carousel-row'}
      >
        <span className={`${selectedId === foodCategory.id && 'active-tab'}`}>
          {foodCategory.name}
        </span>
      </div>
    ));
  };

  return (
    <div className={'text-carousel-section'}>
      <div className={'food-category-mobile'}>
        <div className={'left-arrow'}>
          {outletFoodCategory.length > 0 && calculateWidth() ? leftArrow() : ''}
        </div>
        <div className={'food-category-carousel'}>
          <Slider ref={c => setSlider(c)} {...settings}>
            {renderFoodCategoryCarousel()}
          </Slider>
        </div>
        <div className={'right-arrow'}>
          {outletFoodCategory.length > 0 && calculateWidth()
            ? rightArrow()
            : ''}
        </div>
      </div>
    </div>
  );
};
